import type { BackendTypes } from '@tf/api';
import { Avatar, TFText } from '@tf/ui';
import { S } from '@tf/utils';

import { useOverviewData } from '@/core/api/overview';

type UserInfoWithId = BackendTypes.UserInfo & { id: string };

const ManagerAvatar = ({ item }: { item: UserInfoWithId }) => {
	return (
		<Avatar color="brand" radius="xl" size={32}>
			{S.abbreviate(item.username)}
		</Avatar>
	);
};

interface Props {
	selectedIds: string[];
}

export const AssignedManagersView: React.FC<Props> = (props) => {
	const { data } = useOverviewData();
	const listUsers = data?.listUsers;

	const managers = listUsers ? [...listUsers.map((u) => ({ ...u, id: u.userId }))] : [];
	const selectedManagers = managers.filter((m) => props.selectedIds.includes(m.userId));

	if (!selectedManagers.length) {
		return (
			<TFText c="dimmed" size="13px">
				Not assigned
			</TFText>
		);
	}

	return (
		<Avatar.Group spacing="sm">
			{selectedManagers.map((manager) => (
				<ManagerAvatar key={manager.id} item={manager} />
			))}
		</Avatar.Group>
	);
};
